import i18n from "@/i18n/i18n";
import { onboardingActions } from "../onboardingActions";
import { onboardingContext } from "../onboardingContext";

const COLLAPSE_TRANSITION_MS = 200;

const openHelpMenu = () =>
  new Promise((resolve) => {
    onboardingActions.openHelpMenu();
    setTimeout(resolve, COLLAPSE_TRANSITION_MS);
  });

const closeHelpMenu = () => onboardingActions.closeHelpMenu();

const LMS_LABELS = {
  google: "Google Classroom",
  canvas: "Canvas",
  "canvas-manual": "Canvas",
  schoology: "Schoology",
};

export default () => {
  const { hasClasses } = onboardingContext;
  const availableLms = [
    ...new Set(
      onboardingContext.createGrade
        .filter((g) => LMS_LABELS[g])
        .map((g) => LMS_LABELS[g])
    ),
  ];

  const steps = [
    {
      element: "[data-testid='home-import-student-submissions']",
      popover: {
        title: i18n.t("onboarding.homeWelcome.step1.title"),
        description: i18n.t("onboarding.homeWelcome.step1.description"),
        side: "top",
        align: "center",
        ...(hasClasses && {
          onNextClick: async (_el, _step, { driver }) => {
            await openHelpMenu();
            driver.moveNext();
          },
        }),
      },
    },
  ];

  if (!hasClasses) {
    const classStepItems = [
      i18n.t("onboarding.homeWelcome.classesStep.usePlusButton"),
      ...(availableLms.length
        ? [
            i18n.t("onboarding.homeWelcome.classesStep.importClasses", {
              lmsNames: availableLms.join(", "),
            }),
          ]
        : []),
      i18n.t("onboarding.homeWelcome.classesStep.uploadEssays"),
    ];

    steps.push({
      element: "[data-testid='workspaces-wrapper']",
      popover: {
        title: i18n.t("onboarding.homeWelcome.classesStep.title"),
        description: [
          `${i18n.t(
            "onboarding.homeWelcome.classesStep.whereClassesAppear"
          )}<br>`,
          ...classStepItems.map((item, i) => `${i + 1}. ${item}<br>`),
        ].join(""),
        side: "right",
        align: "start",
        onNextClick: async (_el, _step, { driver }) => {
          await openHelpMenu();
          driver.moveNext();
        },
      },
    });
  }

  steps.push(
    {
      element: "[data-testid='guided-tour-nav-item']",
      popover: {
        title: i18n.t("onboarding.homeWelcome.step2.title"),
        description: i18n.t("onboarding.homeWelcome.step2.description"),
        side: "left",
        align: "start",
        onNextClick: (_el, _step, { driver }) => {
          closeHelpMenu();
          driver.moveNext();
        },
      },
      onDeselected: closeHelpMenu,
    },
    {
      element: "[aria-label='Open chat']",
      popover: {
        title: i18n.t("onboarding.homeWelcome.step3.title"),
        description: i18n.t("onboarding.homeWelcome.step3.description"),
        side: "bottom",
        align: "center",
      },
    }
  );

  return { forceFirstTime: true, stagePadding: 15, steps };
};
